import React from 'react';
import { motion } from 'framer-motion';
const CHECKOUT_URL = 'https://7vtxaf-x1.myshopify.com/cart/45821756342458:1';
export function Product() {
  return <section className="w-full bg-gray-50 py-20 md:py-32 px-4" data-id="element-108">
      <div className="max-w-6xl mx-auto" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-110">
          <h2 className="text-3xl md:text-5xl font-black text-center mb-16" data-id="element-111">
            Sistema completo en 21 días:
          </h2>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-112">
            <div className="order-2 md:order-1" data-id="element-113">
              <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" data-id="element-114">
                <img src="https://cdn.magicpatterns.com/uploads/8oir4cejC94Ra5gXcAVHun/ChatGPT_Image_5_may_2026,_01_57_43_a.m..png" alt="Ebooks del sistema" className="w-full cursor-pointer hover:scale-105 transition-transform duration-300" data-id="element-115" />
              </a>
            </div>

            <div className="order-1 md:order-2 space-y-8" data-id="element-116">
              <div className="bg-white p-8 rounded-xl shadow-lg border-l-4 border-orange-500" data-id="element-117">
                <h3 className="text-2xl font-bold mb-3" data-id="element-118">
                  Ebook 1 — Dejar de procrastinar en 7 días
                </h3>
                <p className="text-lg text-gray-700" data-id="element-119">→ eliminás el problema</p>
              </div>

              <div className="bg-white p-8 rounded-xl shadow-lg border-l-4 border-orange-500" data-id="element-120">
                <h3 className="text-2xl font-bold mb-3" data-id="element-121">
                  Ebook 2 — Crear hábitos en 14 días
                </h3>
                <p className="text-lg text-gray-700" data-id="element-122">→ construís disciplina</p>
              </div>

              <p className="text-xl font-bold text-center md:text-left pt-4" data-id="element-123">
                Primero dejás de sabotearte. Después construís constancia real.
              </p>

              <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="block text-center bg-orange-500 hover:bg-orange-600 text-white font-bold text-xl md:text-2xl px-12 py-6 rounded-xl shadow-2xl transition-all duration-300 w-full" data-id="element-124">
                QUIERO EL SISTEMA COMPLETO
              </motion.a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}